/**
 * usePlaceIntentOptions — fetches "Passar bra för" options from public.tags.
 * Returns active tags (category='place') sorted by label.
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface IntentOption {
  slug: string;
  label: string;
}

export function usePlaceIntentOptions() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["place-intent-options"],
    queryFn: async (): Promise<IntentOption[]> => {
      const { data, error } = await supabase
        .from("tags")
        .select("slug, label")
        .eq("category", "place")
        .eq("is_active", true)
        .order("label", { ascending: true });

      if (error) throw error;
      return (data ?? []).map((t) => ({ slug: t.slug, label: t.label }));
    },
    staleTime: 5 * 60 * 1000, // 5 min cache
  });

  return {
    options: data ?? [],
    loading: isLoading,
    error,
  };
}
